import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from "aurelia-framework";
import { Router } from 'aurelia-router';
import { Models } from "models/core";
import { ErrorService } from "services/error-service";
import { SewingThreadTypeServiceService } from 'services/sewing-thread-type-service-service';
import { ToastService } from 'services/toast-service';

@autoinject
export class SewingThreadTypeServiceNew {
  private sewingThreadTypeService: Models.SewingThreadTypeService = new Models.SewingThreadTypeService();
  protected checkDuplicateData: Models.CheckDuplicateSewingThreadTypeService = new Models.CheckDuplicateSewingThreadTypeService();

  private constructor(
      private errorService: ErrorService,
      private eventAggregator: EventAggregator,
      private router: Router,
      private toastService: ToastService,
      private sewingThreadTypeServiceService: SewingThreadTypeServiceService,
  ) {}

  protected async createSewingThreadTypeService() {
    if (await this.checkDuplicate()) return;

    this.sewingThreadTypeServiceService
      .post(this.sewingThreadTypeService)
      .then(() => {
        this.eventAggregator.publish('sewingThreadTypeServiceListReset', 1);
        this.toastService.showSuccess('sewingThread.created');
        this.router.navigateToRoute('sewing-thread-type-service-list');
      })
      .catch((err) => this.errorService.handleError(err));
  }

  protected async checkDuplicate() {
    this.checkDuplicateData.ProductId = this.sewingThreadTypeService.ProductId;
    const { IsDuplicate } = await this.sewingThreadTypeServiceService.checkDuplicate(this.checkDuplicateData);
    this.eventAggregator.publish('sewingThreadTypeServiceIsDuplicate', IsDuplicate);
    return IsDuplicate;
  }


}